import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const notificationSettingService = createApi({
  reducerPath: "notificationSettingService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getNotificationSetting: builder.query<any, { merchantId: number; page: number; limit: number }>(
      {
        query: (params) => ({
          url: `/notification-settings/${params?.merchantId}`,
          method: "GET",
          headers: params?.merchantId
            ? {
                PageName: "Notification Setting",
              }
            : {},
          params: { page: params?.page, limit: params?.limit },
        }),
      }
    ),
    getDetailNotificationSetting: builder.query<any, { merchantId: number; event: string }>({
      query: (params) => ({
        url: `/notification-settings/${params?.merchantId}/${params?.event}`,
        method: "GET",
        headers: params?.merchantId
          ? {
              PageName: "Notification Setting",
            }
          : {},
      }),
    }),
    updateNotificationSetting: builder.mutation<any, any>({
      query: ({ merchantId, id, ...others }) => ({
        url: `/notification-settings/${merchantId}/${id}`,
        body: others,
        method: "PUT",
        headers: {
          PageName: "Notification Setting",
        },
      }),
    }),
    forceSendingEmailTransaction: builder.mutation<any, any>({
      query: ({ transactionSyncId, ...others }) => ({
        url: `/notification-settings/forcing-email-transaction/${transactionSyncId}`,
        body: others,
        method: "POST",
        headers: {
          PageName: "Notification Setting",
        },
      }),
    }),
  }),
});

export const {
  useGetNotificationSettingQuery,
  useLazyGetNotificationSettingQuery,
  useLazyGetDetailNotificationSettingQuery,
  useUpdateNotificationSettingMutation,
  useForceSendingEmailTransactionMutation,
} = notificationSettingService;
